module.exports = __webpack_public_path__ + "static/media/info-orange.e77a491f.svg";